<script setup lang="ts">
import { statusSeverity } from '../constants/Status';
import type { OrderStatus } from '../types/Order';

const props = defineProps<{ type: OrderStatus }>();
</script>

<template>
  <Tag :value="$t(`status.${type}`)" :severity="statusSeverity[props.type]" :pt="{ root: `${props.type === 'shipped' ? 'bg-gray-500' : ''}` }" />
</template>
